module.exports = __webpack_public_path__ + "static/img/quotes_banner.d4e0f9e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/quotes_banner.png
// module id = uQ59
// module chunks = 3